import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FaxIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FaxIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.4613 17.2407H11.4947C11.2339 17.2586 11.037 17.4846 11.0548 17.7454C11.071 17.9812 11.2588 18.169 11.4947 18.1852H12.4613C12.7221 18.1673 12.919 17.9413 12.9011 17.6805C12.8849 17.4447 12.6972 17.2569 12.4613 17.2407Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.4613 14.937H11.4947C11.2339 14.9549 11.037 15.1808 11.0548 15.4416C11.071 15.6775 11.2588 15.8653 11.4947 15.8814H12.4613C12.7221 15.8636 12.919 15.6376 12.9011 15.3768C12.8849 15.141 12.6972 14.9532 12.4613 14.937Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.437 5.85889H12.1792C11.9117 5.85889 11.6948 6.0758 11.6948 6.34336C11.6948 6.61087 11.9117 6.82778 12.1792 6.82778H18.437C18.7046 6.82778 18.9215 6.61087 18.9215 6.34336C18.9215 6.0758 18.7046 5.85889 18.437 5.85889Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.1791 5.12769H18.4369C18.4584 5.12918 18.4801 5.12918 18.5017 5.12769C18.7625 5.1098 18.9594 4.88388 18.9415 4.62308C18.9236 4.36228 18.6977 4.16538 18.4369 4.18326H12.1791C12.1575 4.18177 12.1358 4.18177 12.1142 4.18326C11.8534 4.20115 11.6565 4.42707 11.6745 4.68787C11.6924 4.94871 11.9183 5.14562 12.1791 5.12769Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1486 14.9376C19.138 14.937 19.1274 14.9368 19.1168 14.937C18.8719 14.9209 18.6602 15.1063 18.6441 15.3513C18.6438 15.3554 18.6436 15.3595 18.6435 15.3637C18.6238 15.6231 18.8182 15.8494 19.0776 15.869C19.0907 15.87 19.1037 15.8704 19.1168 15.8704C19.3648 15.8654 19.5685 15.6731 19.5879 15.4259C19.6014 15.1697 19.4048 14.9511 19.1486 14.9376Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.2147 9.74081H11.3947L11.3991 9.73193H11.3968C10.7132 9.73932 10.165 10.2994 10.1724 10.983V12.3052C10.1724 12.3112 10.1724 12.3171 10.1724 12.3231C10.1774 12.9956 10.7266 13.5369 11.3991 13.5319H19.2214C19.2265 13.5319 19.2318 13.5319 19.2369 13.5319C19.9108 13.5283 20.4539 12.979 20.4502 12.3052V10.983C20.4515 10.299 19.8986 9.74324 19.2147 9.74081ZM19.4991 12.3052C19.4994 12.312 19.4993 12.3188 19.499 12.3256C19.4928 12.4765 19.3655 12.5937 19.2147 12.5875H11.3991C11.3915 12.5878 11.384 12.5878 11.3764 12.5875C11.2268 12.5812 11.1106 12.4549 11.1169 12.3052V10.983C11.1169 10.9793 11.1169 10.9755 11.117 10.9718C11.122 10.8209 11.2483 10.7026 11.3991 10.7075H19.2102L19.2147 10.6986C19.3708 10.701 19.4968 10.827 19.4991 10.983L19.4991 12.3052Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2592 14.9253H15.2948C14.6726 14.9364 14.6726 15.8698 15.2948 15.8698H16.2592C16.8726 15.8698 16.8726 14.9253 16.2592 14.9253Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1658 17.2431C19.1495 17.2414 19.1332 17.2406 19.1168 17.2407C18.8719 17.2245 18.6602 17.41 18.644 17.6549C18.6438 17.6583 18.6436 17.6618 18.6435 17.6652C18.6177 17.9253 18.8077 18.1571 19.0678 18.1829C19.0841 18.1845 19.1004 18.1852 19.1168 18.1852C19.3586 18.1812 19.5601 17.9987 19.5879 17.7585C19.6137 17.4996 19.4247 17.2688 19.1658 17.2431Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2589 17.2407H15.2945C14.6811 17.2407 14.6811 18.1852 15.2945 18.1852H16.2589C16.8722 18.1852 16.8722 17.2407 16.2589 17.2407Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.793 7.92199C21.5306 7.78225 21.165 7.7733 21.165 7.7733H20.6058V2.45891C20.5993 2.35739 20.5184 2.27651 20.4169 2.27002H10.1947C10.0915 2.27673 10.0101 2.36009 10.0058 2.46332V6.67679C10.0056 6.68062 10.0021 6.6831 10.0017 6.68688L10.0058 6.68557V7.77328H8.95261C8.95261 7.77328 8.91344 7.49518 8.72591 7.17553C8.37234 6.68196 7.80898 6.37826 7.1969 6.3789H6.01465C4.93023 6.3789 4.1969 7.20554 4.12575 8.24333C4.11088 8.33701 4.03167 8.40689 3.93686 8.41H3.60798C2.96941 8.41 2.45142 8.927 2.4502 9.56557V19.0833C2.45263 19.7214 2.96995 20.2377 3.60798 20.2389H3.92799C4.02275 20.242 4.10201 20.3119 4.11688 20.4056C4.18798 21.4434 4.92131 22.27 6.00578 22.27H7.1969C8.00683 22.2636 8.72776 21.7553 9.00576 20.9944C9.03677 20.9004 9.12958 20.8409 9.22799 20.8522C9.28035 20.8723 9.33649 20.8806 9.39246 20.8767H21.2214C21.8942 20.8648 22.4372 20.3228 22.4502 19.65V9.02334C22.4506 8.56136 22.1943 8.14382 21.793 7.92199ZM4.10356 19.1211C4.10234 19.2242 4.01777 19.3068 3.91467 19.3056H3.608C3.49459 19.2961 3.41015 19.1968 3.41911 19.0833V9.56107C3.42033 9.45802 3.5049 9.37543 3.608 9.37669H3.91467C3.92553 9.37565 3.93648 9.37565 3.94734 9.37669C4.04264 9.3857 4.11257 9.47028 4.10356 9.56558V19.1211ZM8.15468 20.3567C8.15346 20.8904 7.72176 21.3231 7.18799 21.3256H6.00579C5.48027 21.3123 5.06118 20.8824 5.06136 20.3567V8.29223C5.06379 7.77162 5.48518 7.35024 6.00579 7.3478H7.19691C7.19992 7.34775 7.2029 7.34771 7.20592 7.34766C7.73121 7.34406 8.15993 7.76693 8.16355 8.29222L8.15468 20.3567ZM10.9502 3.40334C10.9577 3.30227 11.0381 3.22189 11.1391 3.21445H19.4525C19.5613 3.21278 19.6532 3.29497 19.6636 3.40334V7.58333C19.6635 7.58964 19.6632 7.5959 19.6625 7.60216C19.6515 7.70715 19.5574 7.7833 19.4525 7.77221H11.1347C11.0316 7.77099 10.949 7.68642 10.9502 7.58332L10.9502 3.40334ZM21.5058 19.65C21.4941 19.8016 21.373 19.9217 21.2214 19.9322H9.40135C9.24968 19.9217 9.12866 19.8016 9.1169 19.65V8.99888C9.13024 8.85523 9.24825 8.74385 9.39248 8.73889H21.2214C21.3775 8.74128 21.5034 8.86726 21.5058 9.02334L21.5058 19.65Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FaxIcon;
